/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  ApiError,
  StripeAccountVerifyResponse,
  StripeAccountsAddResponse,
  StripeAccountsListResponse,
  StripeAccountsLoginResponse,
  StripeAccountsOnboardingResponse,
  StripeCustomersPortalResponse,
  StripeCustomersRetrieveResponse,
  StripePaymentMethodGetResponse,
  StripePaymentMethodListResponse,
  StripeSetupIntentResponse,
  UpdatePaymentMethodBody,
} from '../models/index';
import {
    ApiErrorFromJSON,
    ApiErrorToJSON,
    StripeAccountVerifyResponseFromJSON,
    StripeAccountVerifyResponseToJSON,
    StripeAccountsAddResponseFromJSON,
    StripeAccountsAddResponseToJSON,
    StripeAccountsListResponseFromJSON,
    StripeAccountsListResponseToJSON,
    StripeAccountsLoginResponseFromJSON,
    StripeAccountsLoginResponseToJSON,
    StripeAccountsOnboardingResponseFromJSON,
    StripeAccountsOnboardingResponseToJSON,
    StripeCustomersPortalResponseFromJSON,
    StripeCustomersPortalResponseToJSON,
    StripeCustomersRetrieveResponseFromJSON,
    StripeCustomersRetrieveResponseToJSON,
    StripePaymentMethodGetResponseFromJSON,
    StripePaymentMethodGetResponseToJSON,
    StripePaymentMethodListResponseFromJSON,
    StripePaymentMethodListResponseToJSON,
    StripeSetupIntentResponseFromJSON,
    StripeSetupIntentResponseToJSON,
    UpdatePaymentMethodBodyFromJSON,
    UpdatePaymentMethodBodyToJSON,
} from '../models/index';

export interface CreateStripeAccountsAddRequest {
    body?: object;
}

export interface CreateStripeAccountsIdLoginRequest {
    id: string;
    body?: object;
}

export interface CreateStripeAccountsIdOnboardingRequest {
    id: string;
    businessId?: string;
    body?: object;
}

export interface CreateStripeAccountsIdVerifyRequest {
    id: string;
    body?: object;
}

export interface CreateStripeAccountsListRequest {
    body?: object;
}

export interface CreateStripeCustomersPortalRequest {
    body?: object;
}

export interface CreateStripeWebhooksRequest {
    body: object;
}

export interface DeleteStripePaymentMethodsIdRequest {
    id: string;
}

export interface GetBusinessesIdRefreshRequest {
    id: string;
}

export interface GetBusinessesIdReturnRequest {
    id: string;
    stripeAccountId?: string;
}

export interface GetBusinessesReturnRequest {
    stripeAccountId?: string;
}

export interface GetPaymentsIdSuccessRequest {
    id: string;
}

export interface GetStripePaymentMethodsIdRequest {
    id: string;
}

export interface GetSubscriptionsIdSuccessRequest {
    id: string;
}

export interface UpdateStripePaymentMethodsIdRequest {
    id: string;
    updatePaymentMethodBody?: UpdatePaymentMethodBody;
}

/**
 * CommerceApi - interface
 * 
 * @export
 * @interface CommerceApiInterface
 */
export interface CommerceApiInterface {
    /**
     * Used to create and add a new connect stripe account for merchants.
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeAccountsAddRaw(requestParameters: CreateStripeAccountsAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsAddResponse>>;

    /**
     * Used to create and add a new connect stripe account for merchants.
     */
    createStripeAccountsAdd(requestParameters: CreateStripeAccountsAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsAddResponse>;

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeAccountsIdLoginRaw(requestParameters: CreateStripeAccountsIdLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsLoginResponse>>;

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     */
    createStripeAccountsIdLogin(requestParameters: CreateStripeAccountsIdLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsLoginResponse>;

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     * @param {string} id 
     * @param {string} [businessId] 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeAccountsIdOnboardingRaw(requestParameters: CreateStripeAccountsIdOnboardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsOnboardingResponse>>;

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     */
    createStripeAccountsIdOnboarding(requestParameters: CreateStripeAccountsIdOnboardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsOnboardingResponse>;

    /**
     * Used to verify if the user has successfully connected their stripe account.
     * @param {string} id 
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeAccountsIdVerifyRaw(requestParameters: CreateStripeAccountsIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountVerifyResponse>>;

    /**
     * Used to verify if the user has successfully connected their stripe account.
     */
    createStripeAccountsIdVerify(requestParameters: CreateStripeAccountsIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountVerifyResponse>;

    /**
     * Used to get a list of connected accounts for a merchant.
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeAccountsListRaw(requestParameters: CreateStripeAccountsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsListResponse>>;

    /**
     * Used to get a list of connected accounts for a merchant.
     */
    createStripeAccountsList(requestParameters: CreateStripeAccountsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsListResponse>;

    /**
     * Used to create a signed URL for stripe customer portal.
     * @param {object} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeCustomersPortalRaw(requestParameters: CreateStripeCustomersPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeCustomersPortalResponse>>;

    /**
     * Used to create a signed URL for stripe customer portal.
     */
    createStripeCustomersPortal(requestParameters: CreateStripeCustomersPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeCustomersPortalResponse>;

    /**
     * Create a SetupIntent to collect and verify a card at add time. The returned clientSecret is confirmed client-side with Stripe Elements (confirmCardSetup), which runs the $0 verification authorization that produces AVS/CVC results and evaluates Radar rules. On success the verified card is auto-attached to the customer. 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeSetupIntentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeSetupIntentResponse>>;

    /**
     * Create a SetupIntent to collect and verify a card at add time. The returned clientSecret is confirmed client-side with Stripe Elements (confirmCardSetup), which runs the $0 verification authorization that produces AVS/CVC results and evaluates Radar rules. On success the verified card is auto-attached to the customer. 
     */
    createStripeSetupIntents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeSetupIntentResponse>;

    /**
     * Stripe webhook event receiver
     * @param {object} body 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    createStripeWebhooksRaw(requestParameters: CreateStripeWebhooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe webhook event receiver
     */
    createStripeWebhooks(requestParameters: CreateStripeWebhooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to detach the payment method from the customer\'s account.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    deleteStripePaymentMethodsIdRaw(requestParameters: DeleteStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to detach the payment method from the customer\'s account.
     */
    deleteStripePaymentMethodsId(requestParameters: DeleteStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe account refresh callback — redirects to merchant account page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getAccountsRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe account refresh callback — redirects to merchant account page.
     */
    getAccountsRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe account return callback — redirects to merchant account page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getAccountsReturnRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe account return callback — redirects to merchant account page.
     */
    getAccountsReturn(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe business account refresh callback — redirects to merchant business payouts page.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getBusinessesIdRefreshRaw(requestParameters: GetBusinessesIdRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe business account refresh callback — redirects to merchant business payouts page.
     */
    getBusinessesIdRefresh(requestParameters: GetBusinessesIdRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe business account return callback — redirects to merchant business payouts page with stripeAccountId.
     * @param {string} id 
     * @param {string} [stripeAccountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getBusinessesIdReturnRaw(requestParameters: GetBusinessesIdReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe business account return callback — redirects to merchant business payouts page with stripeAccountId.
     */
    getBusinessesIdReturn(requestParameters: GetBusinessesIdReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe business creation refresh callback — redirects to merchant business creation payouts page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getBusinessesRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe business creation refresh callback — redirects to merchant business creation payouts page.
     */
    getBusinessesRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe business creation return callback — redirects to merchant business creation payouts page with stripeAccountId.
     * @param {string} [stripeAccountId] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getBusinessesReturnRaw(requestParameters: GetBusinessesReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe business creation return callback — redirects to merchant business creation payouts page with stripeAccountId.
     */
    getBusinessesReturn(requestParameters: GetBusinessesReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe payment cancelled callback — redirects to account page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getPaymentsCancelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe payment cancelled callback — redirects to account page.
     */
    getPaymentsCancel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe payment success callback — redirects to account page.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getPaymentsIdSuccessRaw(requestParameters: GetPaymentsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe payment success callback — redirects to account page.
     */
    getPaymentsIdSuccess(requestParameters: GetPaymentsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to get information from a stripe customer.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getStripeCustomersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeCustomersRetrieveResponse>>;

    /**
     * Used to get information from a stripe customer.
     */
    getStripeCustomers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeCustomersRetrieveResponse>;

    /**
     * Used to get a list of payment methods from the customer\'s account.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getStripePaymentMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePaymentMethodListResponse>>;

    /**
     * Used to get a list of payment methods from the customer\'s account.
     */
    getStripePaymentMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePaymentMethodListResponse>;

    /**
     * Used to get a payment method from the customer\'s account.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getStripePaymentMethodsIdRaw(requestParameters: GetStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePaymentMethodGetResponse>>;

    /**
     * Used to get a payment method from the customer\'s account.
     */
    getStripePaymentMethodsId(requestParameters: GetStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePaymentMethodGetResponse>;

    /**
     * Stripe payment processed callback — redirects to account page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getStripeProcessedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe payment processed callback — redirects to account page.
     */
    getStripeProcessed(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe subscription cancelled callback — redirects to account page.
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getSubscriptionsCancelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe subscription cancelled callback — redirects to account page.
     */
    getSubscriptionsCancel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Stripe subscription success callback — redirects to account page.
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    getSubscriptionsIdSuccessRaw(requestParameters: GetSubscriptionsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Stripe subscription success callback — redirects to account page.
     */
    getSubscriptionsIdSuccess(requestParameters: GetSubscriptionsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

    /**
     * Used to update the expiry month & year of the payment method.
     * @param {string} id 
     * @param {UpdatePaymentMethodBody} [updatePaymentMethodBody] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommerceApiInterface
     */
    updateStripePaymentMethodsIdRaw(requestParameters: UpdateStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>>;

    /**
     * Used to update the expiry month & year of the payment method.
     */
    updateStripePaymentMethodsId(requestParameters: UpdateStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void>;

}

/**
 * 
 */
export class CommerceApi extends runtime.BaseAPI implements CommerceApiInterface {

    /**
     * Used to create and add a new connect stripe account for merchants.
     */
    async createStripeAccountsAddRaw(requestParameters: CreateStripeAccountsAddRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsAddResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Merchant", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/accounts/add`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeAccountsAddResponseFromJSON(jsonValue));
    }

    /**
     * Used to create and add a new connect stripe account for merchants.
     */
    async createStripeAccountsAdd(requestParameters: CreateStripeAccountsAddRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsAddResponse> {
        const response = await this.createStripeAccountsAddRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     */
    async createStripeAccountsIdLoginRaw(requestParameters: CreateStripeAccountsIdLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsLoginResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createStripeAccountsIdLogin().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Merchant", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/accounts/{id}/login`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeAccountsLoginResponseFromJSON(jsonValue));
    }

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     */
    async createStripeAccountsIdLogin(requestParameters: CreateStripeAccountsIdLoginRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsLoginResponse> {
        const response = await this.createStripeAccountsIdLoginRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     */
    async createStripeAccountsIdOnboardingRaw(requestParameters: CreateStripeAccountsIdOnboardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsOnboardingResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createStripeAccountsIdOnboarding().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['businessId'] != null) {
            queryParameters['businessId'] = requestParameters['businessId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Merchant", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/accounts/{id}/onboarding`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeAccountsOnboardingResponseFromJSON(jsonValue));
    }

    /**
     * Used to create a signed URL for stripe connect account onboarding.
     */
    async createStripeAccountsIdOnboarding(requestParameters: CreateStripeAccountsIdOnboardingRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsOnboardingResponse> {
        const response = await this.createStripeAccountsIdOnboardingRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to verify if the user has successfully connected their stripe account.
     */
    async createStripeAccountsIdVerifyRaw(requestParameters: CreateStripeAccountsIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountVerifyResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling createStripeAccountsIdVerify().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/stripe/accounts/{id}/verify`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeAccountVerifyResponseFromJSON(jsonValue));
    }

    /**
     * Used to verify if the user has successfully connected their stripe account.
     */
    async createStripeAccountsIdVerify(requestParameters: CreateStripeAccountsIdVerifyRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountVerifyResponse> {
        const response = await this.createStripeAccountsIdVerifyRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of connected accounts for a merchant.
     */
    async createStripeAccountsListRaw(requestParameters: CreateStripeAccountsListRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeAccountsListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Merchant", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/accounts/list`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeAccountsListResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of connected accounts for a merchant.
     */
    async createStripeAccountsList(requestParameters: CreateStripeAccountsListRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeAccountsListResponse> {
        const response = await this.createStripeAccountsListRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Used to create a signed URL for stripe customer portal.
     */
    async createStripeCustomersPortalRaw(requestParameters: CreateStripeCustomersPortalRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeCustomersPortalResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/customers-portal`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeCustomersPortalResponseFromJSON(jsonValue));
    }

    /**
     * Used to create a signed URL for stripe customer portal.
     */
    async createStripeCustomersPortal(requestParameters: CreateStripeCustomersPortalRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeCustomersPortalResponse> {
        const response = await this.createStripeCustomersPortalRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Create a SetupIntent to collect and verify a card at add time. The returned clientSecret is confirmed client-side with Stripe Elements (confirmCardSetup), which runs the $0 verification authorization that produces AVS/CVC results and evaluates Radar rules. On success the verified card is auto-attached to the customer. 
     */
    async createStripeSetupIntentsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeSetupIntentResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/setup-intents`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeSetupIntentResponseFromJSON(jsonValue));
    }

    /**
     * Create a SetupIntent to collect and verify a card at add time. The returned clientSecret is confirmed client-side with Stripe Elements (confirmCardSetup), which runs the $0 verification authorization that produces AVS/CVC results and evaluates Radar rules. On success the verified card is auto-attached to the customer. 
     */
    async createStripeSetupIntents(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeSetupIntentResponse> {
        const response = await this.createStripeSetupIntentsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Stripe webhook event receiver
     */
    async createStripeWebhooksRaw(requestParameters: CreateStripeWebhooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['body'] == null) {
            throw new runtime.RequiredError(
                'body',
                'Required parameter "body" was null or undefined when calling createStripeWebhooks().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';


        let urlPath = `/stripe/webhooks`;

        const response = await this.request({
            path: urlPath,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: requestParameters['body'] as any,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe webhook event receiver
     */
    async createStripeWebhooks(requestParameters: CreateStripeWebhooksRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.createStripeWebhooksRaw(requestParameters, initOverrides);
    }

    /**
     * Used to detach the payment method from the customer\'s account.
     */
    async deleteStripePaymentMethodsIdRaw(requestParameters: DeleteStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling deleteStripePaymentMethodsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/payment-methods/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to detach the payment method from the customer\'s account.
     */
    async deleteStripePaymentMethodsId(requestParameters: DeleteStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteStripePaymentMethodsIdRaw(requestParameters, initOverrides);
    }

    /**
     * Stripe account refresh callback — redirects to merchant account page.
     */
    async getAccountsRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/accounts/refresh`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe account refresh callback — redirects to merchant account page.
     */
    async getAccountsRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAccountsRefreshRaw(initOverrides);
    }

    /**
     * Stripe account return callback — redirects to merchant account page.
     */
    async getAccountsReturnRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/accounts/return`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe account return callback — redirects to merchant account page.
     */
    async getAccountsReturn(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getAccountsReturnRaw(initOverrides);
    }

    /**
     * Stripe business account refresh callback — redirects to merchant business payouts page.
     */
    async getBusinessesIdRefreshRaw(requestParameters: GetBusinessesIdRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesIdRefresh().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/businesses/{id}/refresh`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe business account refresh callback — redirects to merchant business payouts page.
     */
    async getBusinessesIdRefresh(requestParameters: GetBusinessesIdRefreshRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getBusinessesIdRefreshRaw(requestParameters, initOverrides);
    }

    /**
     * Stripe business account return callback — redirects to merchant business payouts page with stripeAccountId.
     */
    async getBusinessesIdReturnRaw(requestParameters: GetBusinessesIdReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getBusinessesIdReturn().'
            );
        }

        const queryParameters: any = {};

        if (requestParameters['stripeAccountId'] != null) {
            queryParameters['stripeAccountId'] = requestParameters['stripeAccountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/businesses/{id}/return`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe business account return callback — redirects to merchant business payouts page with stripeAccountId.
     */
    async getBusinessesIdReturn(requestParameters: GetBusinessesIdReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getBusinessesIdReturnRaw(requestParameters, initOverrides);
    }

    /**
     * Stripe business creation refresh callback — redirects to merchant business creation payouts page.
     */
    async getBusinessesRefreshRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/businesses/refresh`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe business creation refresh callback — redirects to merchant business creation payouts page.
     */
    async getBusinessesRefresh(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getBusinessesRefreshRaw(initOverrides);
    }

    /**
     * Stripe business creation return callback — redirects to merchant business creation payouts page with stripeAccountId.
     */
    async getBusinessesReturnRaw(requestParameters: GetBusinessesReturnRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        if (requestParameters['stripeAccountId'] != null) {
            queryParameters['stripeAccountId'] = requestParameters['stripeAccountId'];
        }

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/businesses/return`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe business creation return callback — redirects to merchant business creation payouts page with stripeAccountId.
     */
    async getBusinessesReturn(requestParameters: GetBusinessesReturnRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getBusinessesReturnRaw(requestParameters, initOverrides);
    }

    /**
     * Stripe payment cancelled callback — redirects to account page.
     */
    async getPaymentsCancelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payments/cancel`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe payment cancelled callback — redirects to account page.
     */
    async getPaymentsCancel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPaymentsCancelRaw(initOverrides);
    }

    /**
     * Stripe payment success callback — redirects to account page.
     */
    async getPaymentsIdSuccessRaw(requestParameters: GetPaymentsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getPaymentsIdSuccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/payments/{id}/success`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe payment success callback — redirects to account page.
     */
    async getPaymentsIdSuccess(requestParameters: GetPaymentsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getPaymentsIdSuccessRaw(requestParameters, initOverrides);
    }

    /**
     * Used to get information from a stripe customer.
     */
    async getStripeCustomersRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripeCustomersRetrieveResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/customers`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripeCustomersRetrieveResponseFromJSON(jsonValue));
    }

    /**
     * Used to get information from a stripe customer.
     */
    async getStripeCustomers(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripeCustomersRetrieveResponse> {
        const response = await this.getStripeCustomersRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to get a list of payment methods from the customer\'s account.
     */
    async getStripePaymentMethodsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePaymentMethodListResponse>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/payment-methods`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripePaymentMethodListResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a list of payment methods from the customer\'s account.
     */
    async getStripePaymentMethods(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePaymentMethodListResponse> {
        const response = await this.getStripePaymentMethodsRaw(initOverrides);
        return await response.value();
    }

    /**
     * Used to get a payment method from the customer\'s account.
     */
    async getStripePaymentMethodsIdRaw(requestParameters: GetStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<StripePaymentMethodGetResponse>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getStripePaymentMethodsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/payment-methods/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => StripePaymentMethodGetResponseFromJSON(jsonValue));
    }

    /**
     * Used to get a payment method from the customer\'s account.
     */
    async getStripePaymentMethodsId(requestParameters: GetStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<StripePaymentMethodGetResponse> {
        const response = await this.getStripePaymentMethodsIdRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Stripe payment processed callback — redirects to account page.
     */
    async getStripeProcessedRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/stripe-processed`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe payment processed callback — redirects to account page.
     */
    async getStripeProcessed(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getStripeProcessedRaw(initOverrides);
    }

    /**
     * Stripe subscription cancelled callback — redirects to account page.
     */
    async getSubscriptionsCancelRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscriptions/cancel`;

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe subscription cancelled callback — redirects to account page.
     */
    async getSubscriptionsCancel(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSubscriptionsCancelRaw(initOverrides);
    }

    /**
     * Stripe subscription success callback — redirects to account page.
     */
    async getSubscriptionsIdSuccessRaw(requestParameters: GetSubscriptionsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling getSubscriptionsIdSuccess().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};


        let urlPath = `/subscriptions/{id}/success`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Stripe subscription success callback — redirects to account page.
     */
    async getSubscriptionsIdSuccess(requestParameters: GetSubscriptionsIdSuccessRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.getSubscriptionsIdSuccessRaw(requestParameters, initOverrides);
    }

    /**
     * Used to update the expiry month & year of the payment method.
     */
    async updateStripePaymentMethodsIdRaw(requestParameters: UpdateStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters['id'] == null) {
            throw new runtime.RequiredError(
                'id',
                'Required parameter "id" was null or undefined when calling updateStripePaymentMethodsId().'
            );
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("User", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }

        let urlPath = `/stripe/payment-methods/{id}`;
        urlPath = urlPath.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters['id'])));

        const response = await this.request({
            path: urlPath,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdatePaymentMethodBodyToJSON(requestParameters['updatePaymentMethodBody']),
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
     * Used to update the expiry month & year of the payment method.
     */
    async updateStripePaymentMethodsId(requestParameters: UpdateStripePaymentMethodsIdRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.updateStripePaymentMethodsIdRaw(requestParameters, initOverrides);
    }

}
